export default __webpack_public_path__ + "static/media/katy_photo.8cedead4.jpeg";